import { findKey } from 'lodash';
import keys from 'config/keys';
import navigationKeys from './config/keys/navigation';
import remoteKeys from './config/keys/remote-keys';
import storage from 'helpers/storage';

const appVersion = process.env.REACT_APP_VERSION || '0.0.0';

export default class Platform {
  remoteKeys = remoteKeys;
  navigationKeys = navigationKeys;
  supportsPreventScroll = true;
  deviceInfo = {};
  deeplink = null;

  initialize(opt) {
    this.options = opt;
    return Promise.resolve();
  }

  forceReload() {
    window.location.hash = '';
    window.location.reload();
  }

  supports3D() {
    return false;
  }

  supportsUHD() {
    return this.deviceInfo.supportsUHD || false;
  }

  supportsUHD8K() {
    return this.deviceInfo.supportsUHD8K || false;
  }

  supportsHDR() {
    return this.deviceInfo.supportsHDR || false;
  }

  getUID() {
    try {
      let duid = storage.get('duid');
      if (!duid) {
        duid = 'testUID12345_' + new Date().getTime();
        storage.set('duid', duid);
        return duid;
      }
      return duid;
    } catch (e) {
      return 'testUID12345';
    }
  }

  getDeviceType() {
    return 'SMART_TV';
  }

  getDeviceRegistrationType() {
    return 'Browser TV Emulator';
  }

  getAppVersion() {
    return appVersion;
  }

  getConnectionType() {
    return this.deviceInfo.connectionType || 'Unknown';
  }

  getSerialNumber() {
    return this.getUID();
  }

  getPlatformVersion() {
    return 'Browser 0.0';
  }

  getModelName() {
    return 'Browser TV';
  }

  getFirmwareVersion() {
    return 'XX.XX.XX';
  }

  getModelYear() {
    return 2023;
  }

  getModelDiagonal() {
    return 0;
  }

  getChipset() {
    return 'unknown';
  }

  registerKeys() {
    // ...
  }

  exit() {
    window.close();
  }

  getBrand() {
    return 'Browser';
  }

  getName() {
    return 'Browser';
  }

  getKeyAction(key) {
    return this.remoteKeys[key];
  }

  getKeyCode(action) {
    return parseInt(findKey(this.remoteKeys, (o) => o === action));
  }

  getKeyCodes(action) {
    return Object.keys(this.remoteKeys)
      .filter((key) => this.remoteKeys[key] === action)
      .map((value) => parseInt(value));
  }

  getKeyCodeNumericValue(keyCode) {
    const keyCodesAndValues = {
      [this.getKeyCode(keys.ZERO)]: '0',
      [this.getKeyCode(keys.ONE)]: '1',
      [this.getKeyCode(keys.TWO)]: '2',
      [this.getKeyCode(keys.THREE)]: '3',
      [this.getKeyCode(keys.FOUR)]: '4',
      [this.getKeyCode(keys.FIVE)]: '5',
      [this.getKeyCode(keys.SIX)]: '6',
      [this.getKeyCode(keys.SEVEN)]: '7',
      [this.getKeyCode(keys.EIGHT)]: '8',
      [this.getKeyCode(keys.NINE)]: '9',
    };

    return keyCodesAndValues[keyCode];
  }
}
